module.exports = __webpack_public_path__ + "static/media/check-fill-info.81eb785d.png";